export default __webpack_public_path__ + "static/34-804f089615ac3121a9340f8327ac482c.png";